import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createI18n } from 'vue-i18n';
import idiomaService from "./services/idioma.services";

import './index.css'

// PrimeVue
import PrimeVue from "primevue/config";
import Aura from '@primevue/themes/aura';
// PrimeVue Icons
import "primeicons/primeicons.css"; 

// i18n
import en from '@/locales/en.json';
import es from '@/locales/es.json';

const idiomaSeleccionado: string = idiomaService.getIdiomaSeleccionado() as string;

const i18n = createI18n({
  legacy: false,
  locale: idiomaSeleccionado,
  fallbackLocale: idiomaSeleccionado,
  globalInjection: true,
  messages: {
    en: en,
    es: es
  }
});

// App configuration
const app = createApp(App)
app.use(i18n);
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      dark: false, // Desactiva el modo oscuro
      darkModeSelector: 'none' 
    }
  }
});

app.mount("#app");

